import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class PrimeEvent {

  $clickSubscription = new EventEmitter();


  private primeUser = new BehaviorSubject<any>({});
  getPrimeUser = this.primeUser.asObservable();

  private primePlan = new BehaviorSubject<any>({});
  getPrimePlan = this.primePlan.asObservable();

  changePrimeUser(primeUser: any) {
    this.primeUser.next(primeUser);
  }

  changePrimePlan(primePlan: any) {
    this.primePlan.next(primePlan);
  }

  emitClickSubscriptionEvent() {
    this.$clickSubscription.emit();
  }   
}
